import React from 'react'
import { Modal } from 'sb-modal'
import { useMemo } from 'sb-hooks'

import { Box, Row } from 'components/_new/layout'
import ProductOffer from './ProductOffer/ProductOffer'

import messages from './messages'


const GiftOfferModalView: React.FunctionComponent<GiftOfferModal.ReturnType> = (props) => {
  const { product, onContinue, onConfirm, onClose } = props

  const modalProps = useMemo(() => ({
    title: messages.title,
    text: messages.text,
    primaryButton: {
      title: messages.buttonTitle.primary,
      onClick: onConfirm,
    },
    ordinaryButton: {
      title: messages.buttonTitle.ordinary,
      onClick: onContinue,
    },
  }), [ onConfirm, onContinue ])

  return (
    <Modal
      className="humbleBgColor"
      {...modalProps}
      dataTestId="giftOfferModal"
      onClose={onClose}
    >
      <Box mt={40}>
        <Row justify="center">
          <ProductOffer product={product} />
        </Row>
      </Box>
    </Modal>
  )
}


export default GiftOfferModalView
